import request from '@/utils/request'

// 分页查询收租记录信息
export function getPageList(params) {
  return request({
    url: '/hrApi/collectRecord',
    method: 'get',
    params: params
  })
}

// 获取收租记录列表
export function getList(params) {
  return request({
    url: '/hrApi/collectRecord/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑收租记录
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/collectRecord',
    method: 'post',
    data: data
  })
}

// 删除收租记录
export function deleteData(id) {
  return request({
    url: '/hrApi/collectRecord/' + id,
    method: 'delete'
  })
}

// 收租
export function confirmRecord(data) {
  return request({
    url: '/hrApi/collectRecord/confirm',
    method: 'put',
    data: data
  })
}

// 续签/续租
export function keepSign(params) {
  return request({
    url: '/hrApi/collectRecord/keep',
    method: 'get',
    params: params
  })
}




// WEBPACK FOOTER //
// ./src/api/collectRecord.js